import * as styles from "./DogListingCard.module.scss";

import React from "react";

import { useMyAccount } from "../../../context";
import image from "../../../static/img/dogComingSoon.svg";
import { getDogAgeBand } from "../../../utils/dates";
import FavouriteIcon from "../../FavouriteIcon/FavouriteIcon";
import { Button } from "../../common";
import { Home, Star } from "../../common/Icons";
import LinkNoStyle, {
	type LinkNoStyleProps,
} from "../../common/LinkNoStyle/LinkNoStyle";
import ProcessedImage from "../../common/ProcessedImage/ProcessedImage";

export interface DogCardProps {
	type: "DogListingCard";
	id: string;
	apiKey: number;
	dog: DogsTrust.DogData;
	name: string;
	frontEndBreedName: string;
	gender: string;
	dob: string;
	size: string;
	centreName: string;
	media: DogsTrust.DogMedia;
	url: string;
	userLocation?: DogsTrust.Place;
	linkId?: string;
	queryStrings?: string;
	isReserved?: boolean;

	isUnderdog?: boolean;
	pagination?: DogsTrust.PaginationProps;
	onClick?: () => void;
}

export const DogListingCard: React.FC<DogCardProps> = ({
	id,
	dog,
	name,
	frontEndBreedName: breed,
	gender,
	dob,
	size,
	centreName,
	media,
	url,
	userLocation,
	linkId,
	isReserved,
	isUnderdog,
	queryStrings,
	pagination,
	onClick,
}) => {
	const { profile } = useMyAccount();
	const isInterested = profile?.interested
		?.map((interestedDog) => interestedDog?.id)
		.includes(dog?.id);
	const heroImage =
		media?.images?.find((img: { isHero?: boolean }) => img.isHero) ||
		media?.images?.[0] ||
		false;

	const Link: React.FC<LinkNoStyleProps> = onClick
		? (props) => <div className={styles.innercontainer}>{props.children}</div>
		: (props) => <LinkNoStyle {...props} />;
	return (
		<div key={id} className={styles.dogcardcontainer}>
			<Link
				className={styles.innercontainer}
				linkId={linkId}
				to={url}
				state={{ userLocation, queryStrings, pagination }}
			>
				<div className={styles.dogcardimagewrapper}>
					<ProcessedImage
						className={
							heroImage ? styles.dogcardimage : styles.dogplaceholderimage
						}
						src={heroImage ? heroImage.src : image}
						alt={
							// biome-ignore lint/complexity/useOptionalChain: Can't use optional chain for union with false
							heroImage && heroImage.alt
								? heroImage.alt
								: `${name} | ${breed} | ${centreName}`
						}
						// biome-ignore lint/complexity/useOptionalChain: Optional chain does not work with false | object union
						aria-hidden={heroImage && heroImage.alt ? "false" : "true"}
						dimensions="400x300"
						width={368}
						height={276}
						isDogImage
						noProcess={!heroImage}
						loading={"lazy"}
					/>
				</div>
				<div className={styles.dogcarddetailscontainer}>
					<div className={styles.dognametext}>{name}</div>
					<div className={styles.dogbreedtext}>{breed}</div>
					<div className={styles.rehomingcentretext}>{centreName}</div>
					<div className={styles.dogcarddetails}>
						{`${gender === "M" ? "Male" : "Female"}   ·   ${getDogAgeBand(
							dob,
						)}   ·   Size: ${size}`}
					</div>
					{isReserved && (
						<div className={styles.dogisreserved}>
							<Star height="14px" width="14px" />
							RESERVED
						</div>
					)}
					{isUnderdog && !isReserved && (
						<div className={styles.dogisunderdog}>
							<Home height="14px" width="14px" />
							UNDERDOG
						</div>
					)}
					{onClick && (
						<Button
							onClick={onClick}
							fullWidth={true}
							variant="secondary"
							disabled={!!(isInterested || profile.interested?.length >= 4)}
							className={styles.addinterested}
						>
							{isInterested ? "Added" : "Add"}
						</Button>
					)}
				</div>
			</Link>

			<FavouriteIcon
				dog={dog}
				dogData={{
					event: "card_favourite",
					card_title: name, // title of card added to wishlist
					card_sub_title: breed, //sub title of card added to wishlist
				}}
			/>
		</div>
	);
};

export default DogListingCard;
